import { getUnleashClient } from "../client";
import type { JsqFlagsGlobalThis } from "../types";

declare let globalThis: JsqFlagsGlobalThis;

export function getFlagsClient(applicationName: string) {
  if (globalThis.__jsqFlagsClient__) return globalThis.__jsqFlagsClient__;

  const client = getUnleashClient(applicationName);
  return (globalThis.__jsqFlagsClient__ = client);
}
